import API from "..";

export default class BatchCertificationStatus {

  constructor({
    statusName,
    isActive,
    displayColor,
    displayOrder
}) 
    
  {
    this.statusName = statusName;
    this.isActive = isActive;
    this.displayColor = displayColor;
    this.displayOrder = displayOrder;
  }

  static async getAllBatchCertificationStatuses() {
    const api = await API();
    const { data } = await api.get(`/batchCertificationStatus`);
    if (data.result) {
        return data.result.map((d) => new BatchCertificationStatus(d));
    }
    else {
        return [];
    }
  }
}
